import { Component } from '@angular/core';

@Component({
  selector: 'scheduler-skeleton',
  templateUrl: './scheduler-skeleton.component.html',
  styleUrl: './scheduler-skeleton.component.scss',
  standalone: false
})
export class SchedulerSkeletonComponent {
  // Generate time slots for the skeleton (9 AM to 9 PM)
  timeSlots: number[] = Array.from({ length: 13 }, (_, i) => i + 9);
}
